import { render } from "./AppFooter.vue?vue&type=template&id=3c7a6ad2"
const script = {}
script.render = render

export default script